import { CarouselItem } from '@wwe-portal/ui/components/carousel';

import {
  FlagshipDesktopSkeleton,
  FlagshipMobileCardSkeleton,
} from '../flagship-skeleton';

import { FlagshipSliderLayout } from './layout';

const Item = () => {
  return (
    <CarouselItem
      className="h-[320px] basis-[calc(100%-32px)] px-3 md:h-[420px] md:basis-full md:px-0"
      data-carousel-item
    >
      <FlagshipMobileCardSkeleton />
      <FlagshipDesktopSkeleton />
    </CarouselItem>
  );
};

export const FlagshipSliderSkeleton = () => {
  return (
    <div>
      <FlagshipSliderLayout hasPagination={false}>
        <Item />
        <Item />
      </FlagshipSliderLayout>
    </div>
  );
};
